export default {
    template: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/mail/state.js